import { useDrag } from "@use-gesture/react";
import styled from "styled-components";
import React, { memo, useCallback, useMemo } from "react";
import clamp from "astrid-helpers/src/clamp";
import map from "astrid-helpers/src/map";
import { dividerColor } from "../../../helpers/color";
import Cursor from "./Cursor";
import { getDuration, useDuration } from "./state/duration";
import { setOffset, useOffset } from "./state/offset";
import { usePosition } from "./state/position";
import { getRect, useRect } from "./state/rect";
import { getSize, useSize } from "./state/size";
const Root = /*#__PURE__*/styled.div.withConfig({
  displayName: "Root",
  componentId: "sc-1t66ipm-0"
})(["position:relative;overflow:hidden;height:30px;margin:0 -2px;"]);
const Handle = /*#__PURE__*/styled.div.withConfig({
  displayName: "Handle",
  componentId: "sc-1t66ipm-1"
})(["position:absolute;top:0;min-width:10px;height:100%;background-color:white;border-left:2px solid ", ";border-right:2px solid ", ";opacity:0.6;pointer-events:none;transform:translateX(-50%);"], dividerColor, dividerColor);
const Line = /*#__PURE__*/styled.div.withConfig({
  displayName: "Line",
  componentId: "sc-1t66ipm-2"
})(["position:absolute;bottom:0;width:0;height:100%;border-left:2px dashed ", ";transform:translateX(-1px);"], dividerColor);
const Navigation = /*#__PURE__*/memo(({
  disabled,
  children,
  onMouseDown: onMouseDownCallback
}) => {
  const size = useSize();
  const offset = useOffset();
  const {
    width
  } = useRect();
  const position = usePosition();
  const duration = useDuration();
  const hours = useMemo(() => duration / (1000 * 60 * 60), [duration]);
  const hourArray = useMemo(() => [...Array(Math.floor(hours)).keys()], [hours]);
  const onDrag = useDrag(useCallback(({
    xy,
    last,
    first,
    event
  }) => {
    event.stopPropagation();
    if (first) {
      onMouseDownCallback && onMouseDownCallback();
    } else if (last) {
      const size = getSize();
      const duration = getDuration();
      const {
        left,
        width
      } = getRect();
      setOffset(clamp(map(xy[0], left, width + left, 0, duration) - size / 2, 0, duration - size));
    } else {
      const duration = getDuration();
      const {
        left,
        width
      } = getRect();
      setOffset(clamp(map(xy[0], left, width + left, 0, duration) - size / 2, 0, duration - size));
    }
  }, [onMouseDownCallback, size]), {
    enabled: !disabled
  });
  return /*#__PURE__*/React.createElement(Root, onDrag(), hourArray.map(h => /*#__PURE__*/React.createElement(Line, {
    key: h,
    style: {
      left: `${(h + 1) / hours * 100}%`
    }
  })), /*#__PURE__*/React.createElement(Handle, {
    style: {
      width: `${size / duration * 100}%`,
      left: `${(offset + size / 2) / duration * 100}%`
    }
  }), children, /*#__PURE__*/React.createElement(Cursor, {
    color: "primary",
    left: Math.round(position / duration * width)
  }));
});
export default Navigation;
//# sourceMappingURL=Navigation.js.map